$(document).ready(function(){

  // Option Selector
  $('.single-option-selector').addClass('form-control margin-bottom');
  
  // Sidebar Dropdown
  $('.dropdown-submenu').click( 
    function(){
      $(this).toggleClass('open');
    });
  $('.dropdown-menu').on({'click':function(e){
      e.stopPropagation();
    }
  });
                           
});